export const toastMsg = {

    loginSuccess: 'Loggedin successfully',
    loginFailed: 'Failed to login',
    loginInvalid: 'Invalid credentials',
    networkError: 'Network error',

    // password reset
    resetSuccess: 'Password reset successfully',
    resetFailed: 'Failed to reset password',


    registerSuccess: 'Registered successfully',
    registerFailed: 'Failed to register',

    orderUpdated: 'Status updated successfully',

    /**Profile */

    documentUploadSuccess: 'Uploaded successfully',
    documentUploadFailed: 'Failed to upload',

    fieldUpdateSuccess: 'Updated successfully',
    fieldUpdateFailed: 'Failed to update',
    fieldEmpty: 'Please give input',
    notYetStart: 'Not yet added',
    refAdd: 'Reference added',
    refFieldEmpty: 'Please give any value',

    profilePicUpdateSuccess: 'Profile pic updated successfully',
    profilePicUpdateFailed: 'Failed to update profile pic',

    storyPicUpdateSuccess: 'Story pic added successfully',
    storyPicUpdateFailed: 'Failed to add story pic',

    logoUpdateSuccess: 'Logo updated successfully',
    logoUpdateFailed: 'Failed to update logo',

    /**Payment **/
    afterPayment: "Payment info created successfully",
    alreadyPayment: 'You have already added payment info',
    addPayment: 'Please add payment info',

    /**Jobs
     * 
     */
    noPdf: 'No pdf has been uploaded',
    confirm: 'Are you sure you want to decline this job ?',
    jobDecline: 'Job Declined successfully',
    paymentFailed: 'Payment failed',
    paymentSuccess: 'Payment success',
    declineStatusCheck: 'Please select reason for decline',
    paymentCheck: 'Please agree all our conditions before checkout',
    statusChanged: 'Status updated', // On progess status updation,
    statusChangedFailed: 'Failed to update status'

}


// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/utils/toastValues.ts